// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"177":"home","535":"login","571":"settings"}[chunkId] + "." + {"177":"3953e413","535":"fdb1cf6c","571":"584084b2"}[chunkId] + ".js";
};